<template>
  <div class="single-location">
    <div class="location-icon mr-3">
      <img v-if="location.id" @click="setUserLocation" :src="`${$store.state.appUrl}/img/pwa/${locationIcon}.svg`" />
    </div>
    <div class="location">
      <span class="location__title" @click="setUserLocation">{{ location.title }}</span>
      <span class="location__address" @click="setUserLocation">{{ location.address }}</span>
      <div class="action-buttons mt-3">
        <span class="text-primary" @click="$emit('set-edit')"> EDIT </span>
        <span class="ml-5 text-primary" @click="$emit('set-delete')"> DELETE </span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    location: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    locationIcon() {
      const tags = this.$getState('userLocationTags')
      if (tags.length) {
        const obj = tags.find(t => t.label == this.location.title)
        return obj && obj.icon || 'location'
      }
    }
  },
  methods: {
    async setUserLocation() {
      this.$setState('load', 1)
      const latlng = {
        lat: this.location.lat,
        lng: this.location.lng
      }
      const obj = {
        title: this.location.title,
        address: `${this.location.address}${this.location.city || ''}`,
        ...latlng
      }
      await this.$http.put(`user/address/${this.location.id}`, { ...this.location, is_primary: 1 })
      this.$store.commit('setPostsFlag', true)
      this.$setState("setAnotherLocation", obj)
      this.$setState('setPrimaryLatlng', latlng)
      this.$setState('setIsCurrent', false)
      setTimeout(this.finish, 1000)
    },
    finish() {
      this.$setState('load', 0)
      this.$router.push(`/${this.$getState('from')}`)
      setTimeout(() => {
        var destination = document.getElementById('post')
        destination.scrollIntoView({
          behavior: 'smooth'
        });
      }, 1000)
    }
  }
}
</script>